export default {
	// 页面固定字符
	_page: {
		// 对话框
		msgbox: {
			ok: 'OK',
			cancel: 'Cancel'
		},

		// 日期选择器
		datePicker: {
			shortcut: {
				today: 'Today',
				yesterday: 'Yesterday',
				week: 'Last 7 days',
				month: 'Last month',
				quarter: 'Last 3 month'
			},
			label: {
				startTime: 'Start time',
				endTime: 'End time',
				year: 'Year',
				month: 'Month',
				weekDay: ['Mon', 'Tues', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun']
			},
			button: {ok: 'Save'}
		},

		// 页面头部
		top: {
			logout: 'Sign out'
		},

		// 登录
		login: {
			caption: 'Sign in',
			register: ['Need an account first?', 'Sign up here'],
			email: {
				text: 'Email',
				placeholder: 'please enter your email'
			},
			password: {
				text: 'Password',
				placeholder: 'Please enter your password'
			},
			button: {
				login: 'Sign in',
				forgetPassword: 'Forgot password?'
			}
		},

		// 注册
		register: {
			caption: 'Sign up',
			login: ['Have an account?', 'Click here to login'],
			role: {
				text: 'Role',
				placeholder: 'I am a：',
				items: {
					cp: 'Advertiser',
					pub: 'Publisher'
				}
			},
			username: {text: 'Contact Name', placeholder: 'Contact name'},
			email: {text: 'Email', placeholder: 'Email'},
			company: {text: 'Company', placeholder: 'Company name'},
			website: {text: 'Website', placeholder: 'Web site'},
			password: {text: 'Password', placeholder: 'Password'},
			repassword: {text: 'Confirm Password', placeholder: 'Confirmation password'},
			passwordNotice: 'Use letters or numbers, at least 6 characters',
			howtoknow: {placeholder: 'How did you hear about us?'},
			agree: ['I agree to the', 'Terms and Privacy Policy'],
			button: {
				register: 'sign up'
			},
			message: {registerSuccess: 'Registration success'}
		},

		// 忘记密码
		forgetPassword: {
			caption: 'Forgot Password',
			register: ['Need an account first?', 'Sign up here'],
			email: {text: 'Email', placeholder: 'please enter your email'},
			password: {text: 'Password', placeholder: 'Please enter a new password'},
			repassword: {text: 'Confirm Password', placeholder: 'Confirm password'},
			button: {
				find: 'Submit',
				login: 'Return to login'
			},
			message: {
				sendMailSuccess: 'Email sent successfully, please pay attention to check.',
				changePasswordSuccess: 'Password reset complete.'
			}
		},

		common: {
			account: {
				caption: 'Basic Info',
				input: {
					username: {
						text: 'Full Name', placeholder: 'Please enter your contact name'
					},
					email: {
						text: 'Email', placeholder: 'Email not allowed to modify'
					},
					company: {
						text: 'Company', placeholder: 'Please enter your company name'
					},
					website: {
						text: 'Website', placeholder: 'Please enter your web site'
					},
					mobile: {
						text: 'Contact number', placeholder: 'Please enter your contact number'
					}
				},
				button: {
					save: 'Save'
				},
				message: {saveSuccess: 'Save successfully！'}
			},

			password: {
				caption: '',
				input: {
					theold: {
						text: 'Current Password', placeholder: 'Please enter the current password'
					},
					thenew: {
						text: 'New Password', placeholder: 'Please enter a new password'
					},
					renew: {
						text: 'Confirm Password', placeholder: 'Please enter your new password again'
					}
				},
				button: {
					save: 'Save'
				},
				message: {saveSuccess: 'Password changed！'}
			}
		}, // common end

		// 广告主
		cp: {
			// 导航
			nav: {
				campaign: 'Campaigns',
				account: 'Account',
				finance: 'Finance',
				accountInfo: 'Basic Info',
				password: 'Password'
			},
			// 广告
			campaign: {
				welcome: ['Welcome to ADYes！', 'Start creating your first ad!', 'Create Campaign'],
				list: {
					bar: {
						createCampaign: 'Create Campaign',
						search: 'Search',
						download: 'Export',
						namePlaceholder: 'Please input the ad name',
						status: 'Choose status'
					},
					title: {
						campaign_name: 'Campaign',
						app_name: 'App',
						os: 'Operating system',
						show_number: 'Impressions',
						click_number: 'Clicks',
						cr: 'CTR',
						install_number: 'Installs',
						ir: 'IR',
						bid: 'CPI',
						spend: 'Cost',
						create_time: 'Create time',
						approval_status: 'Approval Status',
						delivery_status: 'Status',
						day_budget: 'Day Budget',
						operating: 'Operating'
					},
					operate: {
						startup: 'Start', edit: 'Edit', stop: 'Stop'
					}
				}, // list end
				dialog: {
					firstStartup: 'First promotion needs to be approved by Adyes to start, all campaigns will be activated after approved. Are you sure to start the promotion?'
				} // dialog end
			}, // campaign end

			campaignEdit: {
				basic: {
					caption: ['Basic Info', 'To get started please give your campaign a name and select the application you would like to promote.'],
					input: {
						name: {
							text: 'Campaign Name',
							placeholder: 'Give your campaign a descriptive name'
						},
						os: {text: 'Select App to Promote'},
						app_name: {
							text: 'App name',
							placeholder: 'Please enter your app name'
						},
						package_name: {
							text: 'Application package name',
							placeholder: 'Please enter your application package name'
						},
						app_category: {
							text: 'Select Category',
							placeholder: 'Select the category that best describes your application.'
						}
					} // input end
				}, // basic end
				tracking: {
					caption: ['Tracking Method', 'Select what tracking platform you are going to use in order to track installs.'],
					input: {
						method: {
							text: 'Tracking Method'
						}
					}
				},
				targeting: {
					caption: ['Targeting', 'Select your targeting criteria.'],
					input: {
						countries: {
							text: 'Select Countries', placeholder: 'Select where you would like to promote your application.'
						},
						device_type: {
							text: 'Select Device Types', select: {all: 'All Device Types', specific: 'Specific Device Types'}
						},
						os_ver: {
							text: 'Select OS Versions', select: {all: 'All Versions', specific: 'Specific Versions'}
						},
						net_speed: {
							text: 'Connection Speeds', select: {all: 'All Connection Speeds', specific: 'Wife Only'}
						},
						google_facebook: {
							text: 'Do you also need Facebook or Google Ads to promote your product(s)?'
						}
					}
				},
				url: {
					caption: ['Tracking Url', 'Enter your AppsFlyer click URLs. For more help on generating URLs and setting up tracking postbacks.'],
					input: {
						click_url: {
							text: 'Click URL'
						}
					}
				},
				budgets: {
					caption: ['Budgets', 'Select your bid type and define your bids'],
					input: {
						bid_type: {
							text: 'Bid Type'
						},
						bid: {
							text: 'Define your bids', placeholder: 'Please enter your bid'
						},
						day_budget: {
							text: 'Daily Budget Target',
							placeholder: 'Please enter your budget price',
							notice: 'Reminder: raise budget, effective on the day, reduce budget, effective next day'
						}
					}
				},
				save: {
					newCaption: ['Campaign Created', 'Congratulation on your campaign creation!'],
					modifyCaption: ['Ad modify complete'],
					button: {
						ok: 'Finish & Save'
					}
				},
				button: {
					lastStep: 'Return', nextStep: 'Continue'
				},
				message: {
					saveSuccess: 'Ad saved successfully！'
				}
			}, // createCampaign end

			ads: {
				list: {
					bar: {
						createAds: 'Create Ads',
						search: 'Search',
						namePlaceholder: 'Please input the ad name to searh',
						status: 'Please select status'
					},
					title: {
						name: 'Ads',
						app_name: 'APP',
						type: 'Ad Format',
						show_number: 'Impressions',
						click_number: 'Clicks',
						cr: 'CTR',
						install_number: 'Installs',
						ir: 'IR',
						bid: 'CPI',
						spend: 'Cost',
						create_time: 'Create time',
						status: 'Status',
						operating: 'Operating'
					},
					operate: {
						startup: 'Start', edit: 'Edit', stop: 'Stop', view: 'View'
					}
				},
				message: {
					startup: 'After the advertisement originality is enabled, will not be able to carry on the revision again, decides to start?'
				}
			}, // ads end

			adsEdit: {
				caption: ['Create Ads', 'Enter your ads creative name and upload material information'],
				input: {
					name: {text: 'Name', placeholder: 'Enter cteative set name'},
					type: {
						text: 'Type'
					},
					size: {text: 'Size', placeholder: 'Select Size'},
					ads: {text: 'Ads file'},
					adsIcon: {text: 'Ads icon'}
				}, // input end
				button: {
					add: 'Drop files here to upload',
					addIcon: 'Add to app icon here',
					save: 'Save',
					cancel: 'Cancel'
				},
				message: {
					info: 'Please add the "free download", "Play Now" button in the advertising picture, so as to increase the download of the product.',
					fileRequire: 'Material size specification [ {pic_size} ], supports uploading [ {file_type} ] file type, file size must not exceed [ {file_size} ].',
					saveSuccess: 'Save successfully',
					tip: 'ADyes does not accept any advertising material that contains illegal content such as violence, pornography or drugs or may cause user discomfort. Before uploading, please check that your material is in compliance. For violation material, ADyes has the right to stop putting in at any time.',
					previewCaption: 'Advertising styles preview',
					deleteAttachConfirm: 'Are you sure to do it?'
				}
			}, // adsEdit end

			finance: {
				caption: 'Account Balance',
				list: {
					title: { date: 'Date', spend: 'Spend', recharge: 'Recharge' }
				}
			} // finance end
		}, // cp end

		pub: {
			nav: {publish: 'Traffic', account: 'Account', password: 'Password'},
			publish: {
				message: 'No revenue currently. Contact ADyes and get the guide of ADyes SDK integration and start monetizing your apps. Your apps will appear here once you initialize your SDK.'
			}
		}
	},

	// 错误信息
	_error: {
		systemError: 'Server error. Please try again!',
		warning: 'Mistake:',
		noLogin: 'You have not login, or login session overdue, please login!',
		noInput: 'Not filled!',
		noData: 'The data is empty!',
		paramError: 'Parameter error',
		inputError: 'Your input is incorrect.',
		saveDataFailure: 'Data save failed!',

		passwordError: 'Password error!',
		accountOrPasswordError: 'Account or password error！',

		emailInvalid: 'Email is invalid.',
		emailValidFailed: 'Mail validation failed. Please resend the message',
		oldPasswordError: 'Old password error',
		newPasswordError: 'New password error',

		imageError: 'Image is abnormal,Please upload again',
		fileSizeError: 'The attachment size is not legal',
		fileWHError: 'The accessory size is not legal',
		fileExtensionError: 'The attachment type is not legal',
		removeError: 'Delete failed',
		adsNoAttach: 'Please upload ads file',

		registerDataExists: 'Email already registered.',
		attachPostTypeError: 'Upload file type error.',

		moneyNotEnough: 'Account balance not enough.',
		budgetShortage: 'Budget shortage, please raise the budget again after opening.'
	},

	// 其他非页面固定字符
	'List total': 'total',

	'Ads image': 'Image',
	'Ads video': 'Video',
	'Ads native ads': 'Native ads',

	'Status paused': 'Paused',
	'Status active': 'Active',

	'Approval pending': 'Pending',
	'Approval passed': 'Passed',
	'Approval did not pass': 'Did not pass',

	'Option choose one': 'Please choose one',

	'How did you hear about us ?': 'How did you hear about us ?',
	'Friend': 'Friend',
	'Blog/Forum': 'Blog/Forum',
	'Advertising': 'Advertising',
	'Other': 'Other',
	'Yes': 'Yes',
	'No': 'No',

	'Click or Drag and Drop files here upload': 'Click or Drag and Drop files here upload',

	'Africa': 'Africa',
	'Asia': 'Asia',
	'Eastern Europe': 'Eastern Europe',
	'Latin America and the Caribbean': 'Latin America and the Caribbean',
	'North America': 'North America',
	'Oceania (AU, NZ, Pacific Islands)': 'Oceania (AU, NZ, Pacific Islands)',
	'Western Europe': 'Western Europe',
	'Algeria (DZ)': 'Algeria (DZ)',
	'Angola (AO)': 'Angola (AO)',
	'Benin (BJ)': 'Benin (BJ)',
	'Botswana (BW)': 'Botswana (BW)',
	'Burkina Faso (BF)': 'Burkina Faso (BF)',
	'Burundi (BI)': 'Burundi (BI)',
	'Cameroon (CM)': 'Cameroon (CM)',
	'Cape Verde (CV)': 'Cape Verde (CV)',
	'Central African Republic (CF)': 'Central African Republic (CF)',
	'Chad (TD)': 'Chad (TD)',
	'Comoros (KM)': 'Comoros (KM)',
	'Congo (CG)': 'Congo (CG)',
	'Congo, the Democratic Republic of the (CD)': 'Congo, the Democratic Republic of the (CD)',
	'Cote D\' Ivoire (CI)': 'Cote D\' Ivoire (CI)',
	'Djibouti (DJ)': 'Djibouti (DJ)',
	'Egypt (EG)': 'Egypt (EG)',
	'Equatorial Guinea (GQ)': 'Equatorial Guinea (GQ)',
	'Eritrea (ER)': 'Eritrea (ER)',
	'Ethiopia (ET)': 'Ethiopia (ET)',
	'Gabon (GA)': 'Gabon (GA)',
	'Gambia (GM)': 'Gambia (GM)',
	'Ghana (GH)': 'Ghana (GH)',
	'Guinea (GN)': 'Guinea (GN)',
	'Guinea-Bissau (GW)': 'Guinea-Bissau (GW)',
	'Kenya (KE)': 'Kenya (KE)',
	'Lesotho (LS)': 'Lesotho (LS)',
	'Liberia (LR)': 'Liberia (LR)',
	'Libyan Arab Jamahiriya (LY)': 'Libyan Arab Jamahiriya (LY)',
	'Madagascar (MG)': 'Madagascar (MG)',
	'Malawi (MW)': 'Malawi (MW)',
	'Mali (ML)': 'Mali (ML)',
	'Mauritania (MR)': 'Mauritania (MR)',
	'Mauritius (MU)': 'Mauritius (MU)',
	'Mayotte (YT)': 'Mayotte (YT)',
	'Morocco (MA)': 'Morocco (MA)',
	'Mozambique (MZ)': 'Mozambique (MZ)',
	'Namibia (NA)': 'Namibia (NA)',
	'Niger (NE)': 'Niger (NE)',
	'Nigeria (NG)': 'Nigeria (NG)',
	'Reunion (RE)': 'Reunion (RE)',
	'Rwanda (RW)': 'Rwanda (RW)',
	'Saint Helena, Ascension and Tristan da Cunha (SH)': 'Saint Helena, Ascension and Tristan da Cunha (SH)',
	'Sao Tome and Principe (ST)': 'Sao Tome and Principe (ST)',
	'Senegal (SN)': 'Senegal (SN)',
	'Seychelles (SC)': 'Seychelles (SC)',
	'Sierra Leone (SL)': 'Sierra Leone (SL)',
	'Somalia (SO)': 'Somalia (SO)',
	'South Africa (ZA)': 'South Africa (ZA)',
	'South Sudan (SS)': 'South Sudan (SS)',
	'Sudan (SD)': 'Sudan (SD)',
	'Swaziland (SZ)': 'Swaziland (SZ)',
	'Tanzania, United Republic of (TZ)': 'Tanzania, United Republic of (TZ)',
	'Togo (TG)': 'Togo (TG)',
	'Tunisia (TN)': 'Tunisia (TN)',
	'Uganda (UG)': 'Uganda (UG)',
	'Western Sahara (EH)': 'Western Sahara (EH)',
	'Zambia (ZM)': 'Zambia (ZM)',
	'Zimbabwe (ZW)': 'Zimbabwe (ZW)',
	'Afghanistan (AF)': 'Afghanistan (AF)',
	'Armenia (AM)': 'Armenia (AM)',
	'Azerbaijan (AZ)': 'Azerbaijan (AZ)',
	'Bahrain (BH)': 'Bahrain (BH)',
	'Bangladesh (BD)': 'Bangladesh (BD)',
	'Bhutan (BT)': 'Bhutan (BT)',
	'Brunei Darussalam (BN)': 'Brunei Darussalam (BN)',
	'Cambodia (KH)': 'Cambodia (KH)',
	'China (CN)': 'China (CN)',
	'Cyprus (CY)': 'Cyprus (CY)',
	'Georgia (GE)': 'Georgia (GE)',
	'Hong Kong (HK)': 'Hong Kong (HK)',
	'India (IN)': 'India (IN)',
	'Indonesia (ID)': 'Indonesia (ID)',
	'Iran (IR)': 'Iran (IR)',
	'Iraq (IQ)': 'Iraq (IQ)',
	'Israel (IL)': 'Israel (IL)',
	'Japan (JP)': 'Japan (JP)',
	'Jordan (JO)': 'Jordan (JO)',
	'Kazakhstan (KZ)': 'Kazakhstan (KZ)',
	'Korea, Democratic People\'s Republic of (KP)': 'Korea, Democratic People\'s Republic of (KP)',
	'Kuwait (KW)': 'Kuwait (KW)',
	'Kyrgyzstan (KG)': 'Kyrgyzstan (KG)',
	'Lao People\'s Democractic Republic (LA)': 'Lao People\'s Democractic Republic (LA)',
	'Lebanon (LB)': 'Lebanon (LB)',
	'Macao (MO)': 'Macao (MO)',
	'Malaysia (MY)': 'Malaysia (MY)',
	'Maldives (MV)': 'Maldives (MV)',
	'Mongolia (MN)': 'Mongolia (MN)',
	'Myanmar (MM)': 'Myanmar (MM)',
	'Nepal (NP)': 'Nepal (NP)',
	'Oman (OM)': 'Oman (OM)',
	'Pakistan (PK)': 'Pakistan (PK)',
	'Palestinian Territory, Occupied (PS)': 'Palestinian Territory, Occupied (PS)',
	'Philippines (PH)': 'Philippines (PH)',
	'Qatar (QA)': 'Qatar (QA)',
	'Saudi Arabia (SA)': 'Saudi Arabia (SA)',
	'Singapore (SG)': 'Singapore (SG)',
	'Sri Lanka (LK)': 'Sri Lanka (LK)',
	'Syria (SY)': 'Syria (SY)',
	'Taiwan (TW)': 'Taiwan (TW)',
	'Tajikistan (TJ)': 'Tajikistan (TJ)',
	'Thailand (TH)': 'Thailand (TH)',
	'Timor-Leste (TL)': 'Timor-Leste (TL)',
	'Turkey (TR)': 'Turkey (TR)',
	'Turkmenistan (TM)': 'Turkmenistan (TM)',
	'United Arab Emirates (AE)': 'United Arab Emirates (AE)',
	'Uzbekistan (UZ)': 'Uzbekistan (UZ)',
	'Viet Nam (VN)': 'Viet Nam (VN)',
	'Yemen (YE)': 'Yemen (YE)',
	'Korea, Republic of (KR)': 'Korea, Republic of (KR)',
	'Albania (AL)': 'Albania (AL)',
	'Belarus (BY)': 'Belarus (BY)',
	'Bosnia and herzegovina (BA)': 'Bosnia and herzegovina (BA)',
	'Bulgaria (BG)': 'Bulgaria (BG)',
	'Croatia (HR)': 'Croatia (HR)',
	'Czech Republic (CZ)': 'Czech Republic (CZ)',
	'Estonia (EE)': 'Estonia (EE)',
	'Holy See (Vatican City State) (VA)': 'Holy See (Vatican City State) (VA)',
	'Hungary (HU)': 'Hungary (HU)',
	'Latvia (LV)': 'Latvia (LV)',
	'Lithuania (LT)': 'Lithuania (LT)',
	'Macedonia, the Former Yugoslav Republic of (MK)': 'Macedonia, the Former Yugoslav Republic of (MK)',
	'Moldova, Republic of (MD)': 'Moldova, Republic of (MD)',
	'Montenegro (ME)': 'Montenegro (ME)',
	'Poland (PL)': 'Poland (PL)',
	'Romania (RO)': 'Romania (RO)',
	'Russian Federation (RU)': 'Russian Federation (RU)',
	'Serbia (RS)': 'Serbia (RS)',
	'Slovakia (SK)': 'Slovakia (SK)',
	'Slovenia (SI)': 'Slovenia (SI)',
	'Svalbard and Jan Mayen (SJ)': 'Svalbard and Jan Mayen (SJ)',
	'Ukraine (UA)': 'Ukraine (UA)',
	'Aland Islands (AX)': 'Aland Islands (AX)',
	'Anguilla (AI)': 'Anguilla (AI)',
	'Antigua and Barbuda (AG)': 'Antigua and Barbuda (AG)',
	'Argentina (AR)': 'Argentina (AR)',
	'Aruba (AW)': 'Aruba (AW)',
	'Bahamas (BS)': 'Bahamas (BS)',
	'Barbados (BB)': 'Barbados (BB)',
	'Belize (BZ)': 'Belize (BZ)',
	'Bolivia (BO)': 'Bolivia (BO)',
	'Bonaire, Sint Eustatius and Saba (BQ)': 'Bonaire, Sint Eustatius and Saba (BQ)',
	'Brazil (BR)': 'Brazil (BR)',
	'Cayman Islands (KY)': 'Cayman Islands (KY)',
	'Chile (CL)': 'Chile (CL)',
	'Colombia (CO)': 'Colombia (CO)',
	'Costa Rica (CR)': 'Costa Rica (CR)',
	'Cuba (CU)': 'Cuba (CU)',
	'Curacao (CW)': 'Curacao (CW)',
	'Dominica (DM)': 'Dominica (DM)',
	'Dominican Republic (DO)': 'Dominican Republic (DO)',
	'Ecuador (EC)': 'Ecuador (EC)',
	'El Salvador (SV)': 'El Salvador (SV)',
	'Falkland Islands (Malvinas) (FK)': 'Falkland Islands (Malvinas) (FK)',
	'French Guiana (GF)': 'French Guiana (GF)',
	'Grenada (GD)': 'Grenada (GD)',
	'Guadeloupe (GP)': 'Guadeloupe (GP)',
	'Guatemala (GT)': 'Guatemala (GT)',
	'Guyana (GY)': 'Guyana (GY)',
	'Haiti (HT)': 'Haiti (HT)',
	'Honduras (HN)': 'Honduras (HN)',
	'Jamaica (JM)': 'Jamaica (JM)',
	'Martinique (MQ)': 'Martinique (MQ)',
	'Mexico (MX)': 'Mexico (MX)',
	'Montserrat (MS)': 'Montserrat (MS)',
	'Nicaragua (NI)': 'Nicaragua (NI)',
	'Panama (PA)': 'Panama (PA)',
	'Paraguay (PY)': 'Paraguay (PY)',
	'Peru (PE)': 'Peru (PE)',
	'Puerto Rico (PR)': 'Puerto Rico (PR)',
	'Saint Barthélemy (BL)': 'Saint Barthélemy (BL)',
	'Saint Kitts and Nevis (KN)': 'Saint Kitts and Nevis (KN)',
	'Saint Lucia (LC)': 'Saint Lucia (LC)',
	'Saint Martin (French part) (MF)': 'Saint Martin (French part) (MF)',
	'Saint Vincent and the Grenadines (VC)': 'Saint Vincent and the Grenadines (VC)',
	'Sint Maarten (Dutch part) (SX)': 'Sint Maarten (Dutch part) (SX)',
	'Suriname (SR)': 'Suriname (SR)',
	'Trinidad and Tobago (TT)': 'Trinidad and Tobago (TT)',
	'Turks and Caicos Islands (TC)': 'Turks and Caicos Islands (TC)',
	'Uruguay (UY)': 'Uruguay (UY)',
	'Venezuela (VE)': 'Venezuela (VE)',
	'Virgin Islands (VI)': 'Virgin Islands (VI)',
	'Virgin Islands, British (VG)': 'Virgin Islands, British (VG)',
	'Bermuda (BM)': 'Bermuda (BM)',
	'Canada (CA)': 'Canada (CA)',
	'Greenland (GL)': 'Greenland (GL)',
	'Saint Pierre and Miquelon (PM)': 'Saint Pierre and Miquelon (PM)',
	'United States (US)': 'United States (US)',
	'American Samoa (AS)': 'American Samoa (AS)',
	'Australia (AU)': 'Australia (AU)',
	'Cook Islands (CK)': 'Cook Islands (CK)',
	'Fiji (FJ)': 'Fiji (FJ)',
	'French Polynesia (PF)': 'French Polynesia (PF)',
	'Guam (GU)': 'Guam (GU)',
	'Kiribati (KI)': 'Kiribati (KI)',
	'Marshall Islands (MH)': 'Marshall Islands (MH)',
	'Micronesia, Federated States of (FM)': 'Micronesia, Federated States of (FM)',
	'Nauru (NR)': 'Nauru (NR)',
	'New Caledonia (NC)': 'New Caledonia (NC)',
	'New Zealand (NZ)': 'New Zealand (NZ)',
	'Niue (NU)': 'Niue (NU)',
	'Norfolk Island (NF)': 'Norfolk Island (NF)',
	'Northern Mariana Islands (MP)': 'Northern Mariana Islands (MP)',
	'Palau (PW)': 'Palau (PW)',
	'Papua New Guinea (PG)': 'Papua New Guinea (PG)',
	'Pitcairn (PN)': 'Pitcairn (PN)',
	'Samoa (WS)': 'Samoa (WS)',
	'Solomon Islands (SB)': 'Solomon Islands (SB)',
	'Tokelau (TK)': 'Tokelau (TK)',
	'Tonga (TO)': 'Tonga (TO)',
	'Tuvalu (TV)': 'Tuvalu (TV)',
	'Vanuatu (VU)': 'Vanuatu (VU)',
	'Wallis and Futuna (WF)': 'Wallis and Futuna (WF)',
	'Andorra (AD)': 'Andorra (AD)',
	'Austria (AT)': 'Austria (AT)',
	'Belgium (BE)': 'Belgium (BE)',
	'Denmark (DK)': 'Denmark (DK)',
	'Faroe Islands (FO)': 'Faroe Islands (FO)',
	'Finland (FI)': 'Finland (FI)',
	'France (FR)': 'France (FR)',
	'Germany (DE)': 'Germany (DE)',
	'Gibraltar (GI)': 'Gibraltar (GI)',
	'Greece (GR)': 'Greece (GR)',
	'Guernsey (GG)': 'Guernsey (GG)',
	'Iceland (IS)': 'Iceland (IS)',
	'Ireland (IE)': 'Ireland (IE)',
	'Isle of Man (IM)': 'Isle of Man (IM)',
	'Italy (IT)': 'Italy (IT)',
	'Jersey (JE)': 'Jersey (JE)',
	'Liechtenstein (LI)': 'Liechtenstein (LI)',
	'Luxembourg (LU)': 'Luxembourg (LU)',
	'Malta (MT)': 'Malta (MT)',
	'Monaco (MC)': 'Monaco (MC)',
	'Netherlands (NL)': 'Netherlands (NL)',
	'Norway (NO)': 'Norway (NO)',
	'Portugal (PT)': 'Portugal (PT)',
	'San Marino (SM)': 'San Marino (SM)',
	'Spain (ES)': 'Spain (ES)',
	'Sweden (SE)': 'Sweden (SE)',
	'Switzerland (CH)': 'Switzerland (CH)',
	'United Kingdom (GB)': 'United Kingdom (GB)',

	'Books & Reference': 'Books & Reference',
	'Comics': 'Comics',
	'Dating': 'Dating',
	'Education': 'Education',
	'Entertainment(non-gaming)': 'Entertainment(non-gaming)',
	'Finance': 'Finance',
	'Game': 'Game',
	'Health & Fitness': 'Health & Fitness',
	'Jobs': 'Jobs',
	'Lifestyle': 'Lifestyle',
	'Media & Video': 'Media & Video',
	'Music & Audio': 'Music & Audio',
	'News & Magazines': 'News & Magazines',
	'Personalization': 'Personalization',
	'Photography': 'Photography',
	'Productivity': 'Productivity',
	'Shopping': 'Shopping',
	'Social': 'Social',
	'Sports(non-gaming)': 'Sports(non-gaming)',
	'Tools': 'Tools',
	'Transportation': 'Transportation',
	'Travel & Local': 'Travel & Local',
	'Weather': 'Weather',

	'iPod': 'iPod',
	'iPhone': 'iPhone',
	'Tablet': 'Tablet',
	'Phone': 'Phone',

	'iOS': 'iOS',
	'Android': 'Android'
}



// WEBPACK FOOTER //
// ./src/i18n/en-US.js